import { useMemo } from 'react';
import type { TimesheetSubmission } from '../types/timesheet-approval.types';

/**
 * Determine what the current user can do with a given timesheet.
 */
export function useTimesheetPermissions(
  timesheet: TimesheetSubmission | null,
  currentUserId: string,
  isAdmin: boolean,
) {
  return useMemo(() => {
    if (!timesheet) {
      return {
        canApprove: false,
        canReject: false,
        canResubmit: false,
        canReopen: false,
      };
    }

    const isSubmitter = currentUserId === timesheet.userId;
    const isApprover = currentUserId === timesheet.approverUserId;

    return {
      canApprove:
        (isApprover || isAdmin) && timesheet.status === 'submitted',
      canReject:
        (isApprover || isAdmin) && timesheet.status === 'submitted',
      canResubmit:
        (isSubmitter || isAdmin) &&
        ['rejected', 'reopened'].includes(timesheet.status),
      canReopen:
        (isApprover || isAdmin) && timesheet.status === 'approved',
    };
  }, [timesheet, currentUserId, isAdmin]);
}
